import {useMutation} from "@tanstack/react-query";

import {updateServiceCompositionMutationOptions} from "./update-service-composition.mutation-options";

export function useUpdateServiceComposition(id: string) {
  return useMutation(updateServiceCompositionMutationOptions(id));
}
